export const AUTH_TOKEN = "auth_token";
export const ENTRY_POINT = "/auth/login";
export const STORAGE_KEY = "autocard-store-key";
export const STATE_KEYS_TO_SAVE = ["auth", "theme"];

export const UI_MODE = {
  View: "view",
  Edit: "edit",
  New: "new",
};

export const NotificationType = {
  Success: "success",
  Error: "error",
};

export const TransactionType = {
  Income: 1,
  Expense: 2,
  Transfer: 3,
};

export const PaymentTypeTransferEntry = {
  Out: "PaymentTypeTransferOut",
  In: "PaymentTypeTransferIn",
};

export const isPaymentTypeTransfer = (entryType) =>
  entryType === PaymentTypeTransferEntry.Out || entryType === PaymentTypeTransferEntry.In;

export const getTransactionTypeTag = (transactionType) => {
  if (transactionType === TransactionType.Income) {
    return { color: "green", label: "Kirim" };
  }
  if (transactionType === TransactionType.Transfer) {
    return { color: "blue", label: "O'tkazma" };
  }
  return { color: "red", label: "Chiqim" };
};

export const PaymentType = {
  Naqd: 1,
  Karta: 2,
  Bank: 3,
};

export const PaymentTypeOptions = [
  { value: PaymentType.Naqd, label: "Naqd" },
  { value: PaymentType.Karta, label: "Karta" },
  { value: PaymentType.Bank, label: "Bank" },
];

export const getPaymentTypeLabel = (value) => {
  const match = PaymentTypeOptions.find((item) => item.value === value);
  return match ? match.label : "Naqd";
};

export const ExpenseSplitType = {
  Shared: 1,
  Percentage: 2,
  Dividend: 3,
};

export const getExpenseSplitTypeLabel = (splitType) => {
  switch (splitType) {
    case ExpenseSplitType.Shared:
      return "50/50";
    case ExpenseSplitType.Percentage:
      return "Foiz";
    case ExpenseSplitType.Dividend:
      return "Dividend";
    default:
      return "—";
  }
};

export const RoleTypes = {
  Admin: "Admin",
  Buxgalter: "Buxgalter",
  Manager: "Manager",
  Mexanik: "Mexanik",
  Reception: "Reception",
};

export const ContentStatus = {
  Active: 1,
  NotActive: 2,
};
export const TransmissionType = {
  Manual: 1,
  Automatic: 2,
};
export const GroupStatus = {
  All: 0,
  NotStarted: 1,
  Started: 2,
  Finished: 3,
  Archived: 4,
};

export const PaymentStatus = {
  All: 0,
  Paid: 1,
  NotPaid: 2,
  Forgiven: 3,
};

export const ContractStatus = {
  All: 0,
  Approved: 1,
  NotApproved: 2,
  Suspended: 3,
};

export const ContractStatusArray = [
  {
    label: "Tasdiqlanmagan",
    value: ContractStatus.NotApproved,
  },
  {
    label: "Tasdiqlangan",
    value: ContractStatus.Approved,
  },
  {
    label: "Chetlatilgan",
    value: ContractStatus.Suspended,
  },
];

export const GroupStatusArray = [
  {
    label: "Boshlanmagan",
    value: GroupStatus.NotStarted,
    showWhen: [GroupStatus.Started]
  },
  {
    label: "Boshlangan",
    value: GroupStatus.Started,
    showWhen: [GroupStatus.NotStarted, GroupStatus.Finished]
  },
  {
    label: "Yakunlangan",
    value: GroupStatus.Finished,
    showWhen: [GroupStatus.Started, GroupStatus.Archived]
  },
  {
    label: "Arxivlangan",
    value: GroupStatus.Archived,
    showWhen: [GroupStatus.Finished]
  },
];

export const EducationTypeArray = [
  {
    label: "Oliy",
    value: "Oliy",
  },
  {
    label: "O'rta maxsus",
    value: "O'rta maxsus",
  },
  {
    label: "O'rta",
    value: "O'rta",
  },
];
